export const BlueAcorn =
  'https://static.rfstat.com/renderforest/images/website_maker_images/Blue_acorn.svg'
export const WhiteAcorn =
  'https://static.rfstat.com/renderforest/images/website_maker_images/White_acorn.svg'
export const BlackAcorn =
  'https://static.rfstat.com/renderforest/images/website_maker_images/Black_acorn.svg'
